<script>
import { authComputed } from '@/state/helpers'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import api from '@/helpers/api'
export default {
  name: 'account.profile.password',
  data: () => ({
    form: {},
    isLoading: false,
    type: {
      current_password: 'text',
      new_password: 'text'
    }
  }),
  computed: {
    ...authComputed
  },
  mounted () {
    this.onReset()
  },
  methods: {
    async onSave () {
      this.$v.$touch()
      if (!this.$v.$error) {
        const { new_password, current_password } = this.form

        try {
          this.isLoading = true

          await this.$store.dispatch('auth/updateUserPassword', {
            password: new_password,
            current_password
          })
          this.$bvToast.toast(`Password has been updated`, {
            title: 'Password Updated',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
          this.onReset()
        } catch (error) {
          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    },
    onReset () {
      this.form = { id: this.currentUser.id }
      this.$v.$reset()
    }
  },
  validations: {
    form: {
      current_password: {
        required
      },
      new_password: {
        required,
        minLength: minLength(6)
      },
      confirm_password: {
        sameAs: sameAs('new_password')
      }
    }
  }
}
</script>
<template>
  <b-card>
    <g-overlay :show="isLoading">
      <h4 class="font-weight-light mb-3">Change Password</h4>
      <b-form-group
        label="Current Password"
        label-for="cur_pwd"
        label-cols-sm="3"
        label-cols-lg="2"
        label-cols-xl="2"
        class="mb-4 "
      >
        <g-form-password
          :style="{ width: '280px' }"
          id="cur_pwd"
          v-model="form.current_password"
          :class="{ 'is-invalid': $v.form.current_password.$error }"
          v-on:change="$v.form.current_password.$touch()"
          autocomplete="new_passwoord"
          aria-describedby="err_cur_pwd"
        />

        <b-form-invalid-feedback id="err_cur_pwd">
          <span v-if="!$v.form.current_password.required"
            >Current Password is required</span
          >
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="New Password"
        label-for="profile_name"
        label-cols-sm="3"
        label-cols-lg="2"
        label-cols-xl="2"
      >
        <g-form-password
          :style="{ width: '280px' }"
          id="profile_name"
          v-model="form.new_password"
          :class="{ 'is-invalid': $v.form.new_password.$error }"
          v-on:change="$v.form.new_password.$touch()"
          aria-describedby="err_new_password"
        />

        <b-form-invalid-feedback id="err_new_password">
          <span v-if="!$v.form.new_password.required">Password is required</span
          ><span v-if="!$v.form.new_password.minLength"
            >Password is too short (min. 6 characters)</span
          >
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Confirm Password"
        label-for="confirm_password"
        label-cols-sm="3"
        label-cols-lg="2"
        label-cols-xl="2"
      >
        <g-form-password
          :style="{ width: '280px' }"
          id="confirm_password"
          v-model="form.confirm_password"
          :class="{ 'is-invalid': $v.form.confirm_password.$error }"
          v-on:change="$v.form.confirm_password.$touch()"
          aria-describedby="err_confirm_password"
        />

        <b-form-invalid-feedback id="err_confirm_password">
          <span v-if="!$v.form.new_password.sameAs">Passwords do no match</span>
        </b-form-invalid-feedback>
      </b-form-group>
      <div class=" d-flex align-items-end justify-content-end">
        <b-btn
          variant="link"
          class="mr-2"
          v-on:click="onReset"
          :disabled="!$v.$anyDirty"
        >
          Cancel
        </b-btn>
        <b-btn
          variant="primary"
          class=" d-flex align-items-center btn-label"
          v-on:click="onSave"
          :disabled="!$v.$anyDirty"
        >
          <i class="bx bx-save label-icon"></i>Save Changes
        </b-btn>
      </div>
    </g-overlay>
  </b-card>
</template>
